import { AText, Box } from '@alf/uikit';
import { useI18n } from '@namespace/i18n';
import { Image } from '@namespace/icons2';

import styles from './index.module.css';

const RegistrationClosed = () => {
  const { t } = useI18n();

  return (
    <Box direction="column" align="center" className={styles.container}>
      <Image name="general/error" alt="" className={styles.image} />
      <AText
        breed="RU"
        size="xl"
        color="txt_color_3"
        align="center"
        className={styles.text}
      >
        {t('register.closedText')}
      </AText>
    </Box>
  );
};

export default RegistrationClosed;
